import React, { Component, useState, useEffect } from "react";
import { connect } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import { ClipLoader } from "react-spinners";
import Menu from "../shared/Menu";
import Footer from "../shared/Footer";
import Modal from "../Modal/index";
import Dashboard from "./Dashboard";
import MemberInfo from "./MemberInfo";
import AccountInfo from "../MyProfile/AccountInfo";
import UpdateContact from "../MyProfile/UpdateContactInfo";
import ControlContact from "../MyProfile/ControlContactInfo";
import MemberDetail from "./MemberDetail";
import CreatePaymentOrder from "../PaymentOrder/CreatePaymentOrder";
import ListPayments from "../PaymentOrder/ListPayments";
import $ from 'jquery';


import CreatePaymentOrderPayFor from "../PaymentOrderPayFor/CreatePaymentOrderPayFor";
import CreatePayment from "../Payment/CreatePayment";
// import ListPaymentsPayFor from "../PaymentOrderPayFor/ListPaymentsPayFor";


import MyReferences from "../References/MyReferences";
import SubmitReference from "../References/SubmitReference";
import ReferenceRules from "../References/ReferenceRules";
import SubmitDemand from "../Demands/SubmitDemand";
import MyDemands from "../Demands/MyDemands";
import Questions from "./Questions";
import AskToAgent from "../Agent/AskToAgent";
import ResetPassword from "./ResetPassword";
import AnnouncementDetail from "./AnnouncementDetail";
import SmartCalculation from "../Calculation/SmartCalculation";
import { history } from "../../../utilities/history";
import { Route, Switch, Router } from "react-router-dom";
import {
  beginLogout,
  selectAuthenticate,
  refreshToken
} from "../../../state/ducks/login/index";
import { selectAlertMessage } from "../../../state/ducks/alert/index";
import AgentInfo from "./AgentInfo";
import { selectDashboardInfo } from "../../../state/ducks/dashboard";
import AydinlatmaMetni from "../Modal/AydinlatmaMetni";
import SmsVerification from "../Calculation/SmsVerification";
import Result from "../Calculation/Result";
import PersonalInfo from "../Calculation/PersonalInfo";
import NewAddress from "../Calculation/NewAddress";
import CreditCardPayTR from "../PaymentOrderPayTR/CreditCardPayTR";
import CreatePaymentOrderPayTr from "../PaymentOrderPayTR/CreatePaymentOrderPayTr";
import CreatePaymentOrderEminPay from "../PaymentOrderEminPay/CreatePaymentOrderEminPay";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { v4 as uuidv4 } from 'uuid';

function changebg() {
  document.body.background = "";
  document.body.className = "t-dashboardBack";
}
function modalWithControl(Width) {

  var modalGenel = document.getElementById("id-modalTipi");
  var modalIptal = document.getElementById("id-modalIptal");
  if (modalGenel != null) {
    // ekranı sürekli dinle
    window.addEventListener("resize", function () {
      if (window.innerWidth < 900) {
        modalGenel.style.width = "90%"; // Modal Genişlipği
        if (modalIptal != null) {

          modalIptal.style.width = "90%"
        }
      } else {
        modalGenel.style.width = "55%"; // Modal Genişlipği
        if (modalIptal != null) {

          modalIptal.style.width = "30%";
        }
      }
    });

  }

}

class Home extends Component {
  state = {
    windowWidth: "0",
    intervalId: null,
    timerCount: 0,
    timerDuration: 30
  }
  beginLogout = () => {
    this.props.beginLogout();
  };

  componentDidMount() {
    changebg();
    window.addEventListener('resize', this.handleWindowSizeChange);
    // Timer'ı başlat
    this.startTimer();
    var count = parseInt(sessionStorage.getItem("tokenExpireTime"))
    if (count < 30) {
      this.setState({ timerDuration: count, timerKey: uuidv4() });
    }
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
    clearInterval(this.state.intervalId);
  }

  handleWindowSizeChange = () => {
    this.setState({ windowWidth: window.innerWidth });

    //  modalWithControl(this.state.windowWidth)
  };

  expireTokenYes = () => {

    sessionStorage.setItem("tokenExpireTime", (35).toString())
    $("#expireTokenModal").modal('hide');
    refreshToken().then((login) => {
      sessionStorage.setItem("token", login.token);
      sessionStorage.setItem("refreshToken", login.refreshToken);
      sessionStorage.setItem("tokenExpireTime", (login.tokenExpireTime * 60).toString())
      // sessionStorage.setItem("tokenExpireTime", (60).toString())

    });
  }

  uniqId = () => {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
  };

  expireTokenNo = () => {
    this.props.beginLogout();
  }

  startTimer = () => {
    const intervalId = setInterval(() => {


      var count = parseInt(sessionStorage.getItem("tokenExpireTime")) - 1;
      this.setState({ timerCount: count });
      sessionStorage.setItem("tokenExpireTime", count.toString());
      if (count <= 0) {
        clearInterval(this.state.intervalId);
        this.props.beginLogout();
      }
      else if (count <= 30) {
        if (count == 30) {
          this.setState({ timerDuration: count, timerKey: uuidv4() });
        }
        $("#expireTokenModal").modal('show');
      }

    }, 1000);

    this.setState({ intervalId });
  };


  render() {
    const { login, alert, dashboard } = this.props;


    return (

      <LoadingOverlay active={alert?.loading} spinner={<ClipLoader />} styles={{
        overlay: (base) => ({
          ...base,
          position: 'fixed'
        })
      }}>

        <Router history={history}>
          <Modal message={alert?.message} type={alert?.type} />
          <AydinlatmaMetni></AydinlatmaMetni>

          <div className="t-container ml-auto mr-auto">
            <div className="t-solMenuArea">
              <div className="t-solmenuicerik">
                <div className="container-fluid">
                  <div className="row pt-3" style={{ backgroundColor: "#242423" }}>
                    <div className="col-12 d-flex justify-content-end">
                      <img
                        src="/assets/img/svg/logo_internetSube.svg"
                        style={{ width: 70 }}
                      />
                    </div>
                  </div>
                  <div
                    className="row pb-4 pt-2 px-2 d-flex align-items-center"
                    style={{ backgroundColor: "#242423" }}
                  >
                    <div className="col-auto pr-1">
                      <img src="/assets/img/svg/icon_avatar.svg" style={{ width: 70 }} />
                    </div>
                    <div className="col d-flex flex-column px-1">
                      <span className="t-isim">{login.info.username}</span>
                      <span className="t-hosgeldiniz">Hoşgeldiniz</span>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 p-0 t-solmenu">
                      <ul
                        className="accordion"
                        id="sol_menu"
                        style={{ padding: "0 0 50px 0" }}
                      >
                        <Menu count={dashboard.menuCount}></Menu>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="t-solMenuGuvenliCikis">
                <a href="#"
                  onClick={this.beginLogout}>
                  <i className="t-icon-switch" />
                  GÜVENLİ ÇIKIŞ
                </a>
              </div>
            </div>
            <div className="t-sagicerik">
              <div className="t-mobilMenuArea">
                <div className="t-mobilMenu">
                  <img src="/assets/img/svg/logo_internetSube.svg" style={{ height: 45 }} />
                  <a
                    className="t-icon-menu1"
                    data-toggle="collapse"
                    href="#mobilmenu"
                    style={{ fontSize: "30pt" }}
                  />
                </div>
              </div>
              <div className="t-MobilMenuAltArea">
                <div className="collapse" id="mobilmenu">
                  {/*  Mobil MENU */}
                  <div className="container-fluid" style={{ backgroundColor: "#302d2e" }}>
                    <div className="row p-2 d-flex align-items-center">
                      <div className="col-auto pr-1">
                        <img src="/assets/img/svg/icon_avatar.svg" style={{ width: 70 }} />
                      </div>
                      <div className="col d-flex flex-column px-1">
                        <span className="t-isim">{login.info.username}</span>
                        <span className="t-hosgeldiniz">Hoşgeldiniz</span>
                      </div>
                      <div className="col-auto t-mobilIconClose">
                        <a className="t-icon-switch" href="#" onClick={this.beginLogout} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12 p-0 t-solmenu">
                        <ul
                          className="accordion"
                          id="ust_menu"
                          style={{ backgroundColor: "#3C3C3B" }}
                        >
                          <Menu count={dashboard.menuCount} ></Menu>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/*  Mobil MENU BİTTİ */}
                </div>
              </div>
              <Switch>
                <Route
                  exact
                  path="/Home/DashBoard"
                  render={props => <Dashboard login={login} {...props} />}
                />
                <Route
                  exact
                  path="/Home/MemberInfo"
                  component={MemberInfo}
                />
                <Route
                  exact
                  path="/Home/AccountInfo"
                  component={AccountInfo}
                />
                <Route exact path="/Home/AgentInfo" component={AgentInfo} />
                <Route
                  exact
                  path="/Home/MemberDetail/:id"
                  component={MemberDetail}
                />
                <Route
                  exact
                  path="/Home/CreatePaymentOrder"
                  component={CreatePaymentOrder}
                />
                <Route
                  exact
                  path="/Home/ListPayments"
                  component={ListPayments}
                />

                <Route
                  exact
                  path="/Home/CreatePaymentOrderPayFor"
                  component={CreatePaymentOrderPayFor}
                />



                <Route
                  exact
                  path="/Home/CreatePayment"
                  render={props => <CreatePayment dashboard={dashboard} {...props} />}
                />

                {/* <Route
                  exact
                  path="/Home/ListPaymentsPayFor"
                  component={ListPaymentsPayFor}
                /> */}


                <Route
                  exact
                  path="/Home/SubmitReference"
                  component={SubmitReference}
                />
                <Route
                  exact
                  path="/Home/MyReferences"
                  component={MyReferences}
                />
                <Route
                  exact
                  path="/Home/ReferenceRules"
                  component={ReferenceRules}
                />
                <Route
                  exact
                  path="/Home/SubmitDemand"
                  component={SubmitDemand}
                />
                <Route exact path="/Home/MyDemands" component={MyDemands} />
                <Route exact path="/Home/Questions" component={Questions} />
                <Route
                  exact
                  path="/Home/AskToAgent"
                  component={AskToAgent}
                />
                <Route
                  exact
                  path="/Home/ResetPassword"
                  component={ResetPassword}
                />
                <Route
                  exact
                  path="/Home/AnnouncementDetail/:id"
                  component={AnnouncementDetail}
                />
                <Route
                  exact
                  path="/Home/SmartCalculation"
                  component={SmartCalculation}
                />
                <Route
                  exact
                  path="/Home/SmsVerification"
                  component={SmsVerification}
                />
                <Route
                  exact
                  path="/Home/PersonalInfo"
                  component={PersonalInfo}
                />
                <Route
                  exact
                  path="/Home/NewAddress"
                  component={NewAddress}
                />
                <Route
                  exact
                  path="/Home/Result"
                  component={Result}
                />
                <Route
                  exact
                  path="/Home/ControlContactInfo/:id"
                  component={ControlContact}
                />
                <Route
                  exact
                  path="/Home/UpdateContactInfo/:id"
                  component={UpdateContact}
                />
                <Route
                  exact
                  path="/Home/CreditCardPayTR"
                  component={CreditCardPayTR}
                />
                <Route
                  exact
                  path="/Home/CreatePaymentOrderPayTr"
                  component={CreatePaymentOrderPayTr}
                />
                <Route
                  exact
                  path="/Home/CreatePaymentOrderEminPay"
                  component={CreatePaymentOrderEminPay}
                />
              </Switch>
              <Footer></Footer>
            </div>

          </div>
        </Router>


        <div className="modal" id="expireTokenModal" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="t-modalAreaMailOrder" id="id-modal" style={{ display: "block" }}>
            {/* Bu kısım animasyon için Hareket eden kısım. */}
            <div className="t-modalContentMailOrder" id="id-modalTipi" style={(window.innerWidth <= 900) ? { width: "80%" } : { width: "30%" }}>
              <div
                className="t-modalMailOrder"
                id="id-modalGenel"
                style={{ backgroundColor: "rgb(255, 255, 255)", boxShadow: "3px 3px 3px #939191" }}
              >
                <div className="container-fluid">
                  {/* Header */}
                  <div className="row t-modalHeaderMailOrder">
                    <div
                      className="col text-center"
                      id="id-modalHeader"
                      style={{ color: "rgb(119, 119, 119)" }}
                    >
                      DEVAM ETMEK İSTİYOR MUSUNUZ?
                    </div>
                    {/* <div className="col-auto t-cursorPointer" data-dismiss="modal">
                      <i
                        className="t-icon-cross"
                        id="id-modalHeaderIcon"
                        style={{ color: "rgb(119, 119, 119)" }}
                      />
                    </div> */}
                  </div>
                  {/* Body */}
                  <div className="row t-modalBodyMailOrder" style={{ minHeight: "120px" }}>
                    <div
                      className="col-12 text-center"
                      id="id-modalBody"
                      style={{ color: "rgb(119, 119, 119)" }}
                    >
                      {/* <strong style={{ fontSize: "32pt", color: "red" }}>
                        {this.state.timerCount}
                      </strong> */}
                      <br />
                      <div className="text-center" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CountdownCircleTimer
                          isPlaying
                          duration={this.state.timerDuration}
                          colors="#3AAA35"
                          size={100}
                          key={this.state.timerKey}
                        >
                          {({ remainingTime }) => remainingTime}
                        </CountdownCircleTimer>
                      </div>

                      <br />
                      <br />
                      <strong className="mt-4">
                        Oturumunuz sonlandırılacaktır. Devam etmek istiyor musunuz?
                      </strong>
                    </div>
                  </div>
                  {/* footer*/}
                  <div className="row t-modalFooterMailOrder">
                    <div
                      className="col-12"
                      id="id-modalFooter"
                      style={{ color: "rgb(102, 102, 102)" }}
                    />
                    <div className="col-12 d-flex justify-content-center pb-3">
                      <button className="t-icButonKirmizi text-center mr-4" style={{ width: 100, justifyContent: "center" }} onClick={this.expireTokenNo}>
                        Hayır
                      </button>

                      <button className="t-icButtonYesil  text-center ml-4" style={{ width: 100, justifyContent: "center" }} onClick={this.expireTokenYes}>
                        Evet
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </LoadingOverlay >
    );
  }
}

const mapStateToProps = state => {
  return {
    login: selectAuthenticate(state),
    alert: selectAlertMessage(state),
    dashboard: selectDashboardInfo(state)
  };
};

const mapDispatchToProps = dispatch => ({
  beginLogout: () => dispatch(beginLogout())
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
export {
  history
};
